import { Badge } from "./ui/badge";
import { PRIORITIES, TASK_STATUSES } from "../lib/api";

export function PriorityBadge({ value }) {
  const p = PRIORITIES.find((x) => x.key === value) || PRIORITIES[1];
  return (
    <Badge className={`${p.color} border`} variant="outline" data-testid={`priority-${value}`}>
      {p.label}
    </Badge>
  );
}

export function StatusBadge({ value }) {
  const s = TASK_STATUSES.find((x) => x.key === value) || TASK_STATUSES[0];
  return (
    <Badge className={`${s.color} border`} variant="outline" data-testid={`status-${value}`}>
      {s.label}
    </Badge>
  );
}

export function StageBadge({ label }) {
  return (
    <Badge className="bg-[hsl(var(--brand-blue))/0.15] text-white border-[hsl(var(--brand-blue))/0.5] border" variant="outline">
      {label}
    </Badge>
  );
}
